var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProgressBarBlankStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-7{fill:none;}.cls-2{clip-rule:evenodd;}.cls-3{clip-path:url(#clip-path);}.cls-4{clip-path:url(#clip-path-2);}.cls-5{fill:#fff;}.cls-6{clip-path:url(#clip-path-3);}.cls-7{stroke:#ffc7d4;stroke-miterlimit:10;stroke-width:4px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-281 -196)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295,
    cy: 210,
    r: 9.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-281 -196)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 375,
    height: 798
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(-281 -196)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M295,219a9,9,0,1,0-9-9A9,9,0,0,0,295,219Zm-21-30h42v42H274Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "blank_star") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 28,
    height: 28
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 14,
    cy: 14,
    r: 9
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressBarBlankStar);
export default __webpack_public_path__ + "static/media/progress_bar_blank_star.cda9ef0c422d65043f23e0fb7dd9cd49.svg";
export { ForwardRef as ReactComponent };